<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商家">
						<el-select v-model="searchInfo.storeId" filterable 
							:remote-method="remoteMethod" :loading="storeLoading" remote
							reserve-keyword placeholder="请选择" >
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item> 

					<el-form-item label="单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderNo" placeholder="请输入单号">
						</el-input>
					</el-form-item>
					

					<el-form-item label="提现类型" class='tiny '>
						<el-select v-model="searchInfo.type" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="店铺提现" :value="1">店铺提现</el-option>
							<el-option key="2" label="服务商提现" :value="2">服务商提现</el-option>
							<el-option key="3" label="店铺个人资产提现" :value="3">店铺个人资产提现</el-option>
						
						</el-select>
					</el-form-item>
					<el-form-item label="状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option key="0" label="审核中" :value="0">审核中</el-option>
							<el-option key="1" label="转帐中" :value="1">转帐中</el-option>
							<el-option key="2" label="提现成功" :value="2">提现成功</el-option>
							<el-option key="3" label="用户撤销" :value="3">用户撤销</el-option>
							<el-option key="4" label="驳回" :value="4">驳回</el-option>
						
						</el-select>
					</el-form-item>

					<el-form-item label="更新时间">
						<div class="block">
							<el-date-picker v-model="timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button>
							</el-button> -->
							<!-- <el-button type="primary" @click="applyWithdrawal"> 申请提现 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
			<div style="padding-left:20px;padding-bottom:10px;">
				汇总金额：￥ {{ allData ? allData : 0 | intToFloatfour | cutZero }}
			</div>
		</div>
		
		<el-table :data="withdrawal.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			
			<el-table-column prop="storeName" label="商家名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderNo" label="单号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="amount" label="结算金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fees" label="手续费" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">审核中</div>
					<div v-if="scope.row.status == 1">转帐中</div>
					<div v-if="scope.row.status == 2">提现成功</div>
					<div v-if="scope.row.status == 3">用户撤销</div>
					<div v-if="scope.row.status == 4">驳回</div>
				</template>
			</el-table-column>
			<el-table-column prop="type" label="提现类型" align="center" :show-overflow-tooltip="true" width="150">
				<template slot-scope="scope">
					<div v-if="scope.row.type == 1">店铺提现</div>
					<div v-if="scope.row.type == 2">服务商提现</div>
					<div v-if="scope.row.type == 3">店铺个人资产提现</div>
				</template>
			</el-table-column>
			<el-table-column prop="invoiceType" label="发票类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.invoiceType == 0">无发票</div>
					<div v-if="scope.row.invoiceType == 1">电子发票</div>
					<div v-if="scope.row.invoiceType == 2">纸质发票</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="发票信息" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" v-if="scope.row.invoiceType != 0" 
					@click="queryClick(scope.row)">查看
					</el-button>
				</template>
			</el-table-column>



			<el-table-column label="收款信息" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="queryIntegralWithdrawal(scope.row,1,'收款信息')">查
						看
					</el-button>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="platformSerialNo" label="流水号" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="checkDatetime" label="审核时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.checkDatetime">{{scope.row.checkDatetime}}</div>
					<div v-else>未审核</div>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="驳回原因" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">

					<div v-if="scope.row.reason">{{scope.row.reason}}</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center" width="140">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status == 0" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row,2,'打 款')">通 过</el-button>
					<el-button v-if="scope.row.status == 0 || scope.row.status == 1" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row,4,'驳 回')">驳 回</el-button>
					<el-button v-if="scope.row.status == 1" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row,3,'打 款')">继续打款</el-button>
					<!-- <el-button v-if="scope.row.status == 0" size="small" type="text" @click="revoke(scope.row.id)">撤
						销</el-button> -->
					<div v-if="scope.row.status == 4">不可操作</div>
					<el-button v-if="scope.row.status == 2" size="small" type="text"
						@click="showContent(scope.row.systemDocuments)">
						查看打款凭证
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="withdrawal.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="withdrawal.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- <el-dialog style="float:rigin" title="查看收款信息" :closeOnClickModal="false" :visible.sync="dialogDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号" class="redItem" style="width: 50%;">
							{{payment.cardNo}}
						</el-form-item>

						<el-form-item label="收款人姓名:" class="redItem" style="width: 50%;">
							{{payment.cardUserName}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号类型:" class="redItem" style="width: 50%;">
							<div v-if="payment.cardType == 1">对公</div>
							<div v-if="payment.cardType == 2">对私</div>
						</el-form-item>

						<el-form-item v-if="payment.cardType == 1" label="对公收款账号:" class="redItem"
							style="width: 50%;">
							{{payment.cardChannelNo}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开户行:" class="redItem" style="width: 50%;">
							{{payment.cardBank}}
						</el-form-item>

						<el-form-item label="开户支行:" class="redItem" style="width: 50%;">
							{{payment.cardSubbranch}}
						</el-form-item>
					</div>
				</el-form>

			</div>
			<div style="text-align: center;">
				<el-button @click="dialogDatil = false">取 消</el-button>
				<el-button  type="primary" v-if="type==4" @click="bohui">驳 回</el-button>
				<el-button type="primary" v-if="type==0" @click="confirm">通 过</el-button>
			</div>
		</el-dialog> -->

		<el-dialog style="float:rigin" title="申请提现" :closeOnClickModal="false" :visible.sync="applyDatil" width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item v-if="storeInfo.storeCardType == 2" label="收款人姓名:" class="redItem"
							style="width: 60%;">
							{{storeInfo.storeCardName}}
						</el-form-item>
						<el-form-item v-if="storeInfo.storeCardType == 1" label="收款账户:" class="redItem"
							style="width: 60%;">
							{{storeInfo.storeCardName}}
						</el-form-item>
						<el-form-item label="收款账号:" class="redItem" style="width: 40%;">
							{{storeInfo.storeCardBankNo}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开户行:" class="redItem" style="width: 60%;">
							{{storeInfo.storeCardBank}}
						</el-form-item>

						<el-form-item label="开户支行:" class="redItem" style="width: 40%;">
							{{storeInfo.storeCardSubbranch}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="提现金额:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;" v-model="amount" placeholder="请输入提现金额">
							</el-input>
						</el-form-item>
						<el-form-item label="提现额度:" class="redItem" style="width: 40%;">
							{{limtInfo.Store_Withdrawal_Min}} ~~~ {{limtInfo.Store_Withdrawal_Max}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="单日提现额度:" class="redItem" style="width: 40%;">
							{{storeInfo.limitDayAmount}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="联系电话:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;" v-model="storeInfo.phone" disabled placeholder="请输入联系电话">
							</el-input>
							<el-button v-if="flag" type="primary" @click="code"
								style="border-radius: 30px;margin-left: 10px;">获取验证码</el-button>
							<el-button v-else type="primary" disabled
								style="border-radius: 30px;margin-left: 10px;">{{count}}S</el-button>
						</el-form-item>
						<el-form-item label="验证码:" class="redItem" style="width: 40%;">
							<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入验证码">
							</el-input>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="安全密码:" class="redItem" style="width: 60%;">
							<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入安全密码">
							</el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="applyDatil = false">取 消</el-button>
				<el-button type="primary" @click="sure" :loading="sureLoading">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 查看收款信息 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">
		
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
		
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号" class="redItem" style="width: 50%;">
							{{payment.cardNo}}
						</el-form-item>
					
						<el-form-item label="收款人姓名:" class="redItem" style="width: 50%;">
							{{payment.cardUserName}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号类型:" class="redItem" style="width: 50%;">
							<div v-if="payment.cardType == 1">对公</div>
							<div v-if="payment.cardType == 2">对私</div>
						</el-form-item>
					
						<el-form-item v-if="payment.cardType == 1" label="对公收款账号:" class="redItem"
							style="width: 50%;">
							{{payment.cardChannelNo}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开户行:" class="redItem" style="width: 50%;">
							{{payment.cardBank}}
						</el-form-item>
					
						<el-form-item label="开户支行:" class="redItem" style="width: 50%;">
							{{payment.cardSubbranch}}
						</el-form-item>
					</div>
		
					<div v-if=" type == 3" style="display: flex;align-items: center;justify-content: space-between;">
		
						<el-form-item label="充值金额:">
							{{payment.amount}}
						</el-form-item>
					
							<el-form-item   label="打款凭证">
								<!-- 图片上传 -->
								<el-upload class="avatar-uploader" :action="httpUrl"  
									:before-upload="beforeAvatarUpload" multiple :show-file-list="false"
									:on-success="onSuccess">
									<img style="width: 100px;height: 100px;" v-if="payment.systemDocuments" :src="payment.systemDocuments" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
					
					</div>
					
					<div v-if="type == 4" style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="驳回原因:"  style="width: 100%;">
							<!-- <el-input style="width: 100%;" v-model="integralWithdrawal.reason" placeholder="请输入驳回原因">
							</el-input> -->
							<el-input style="width: 100%;" v-model="reason" placeholder="请输入驳回原因"></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" v-if="type==2" @click="confirm" :loading="confirmLoading">通 过</el-button>
				<el-button v-if="type == 3" type="primary" @click="remit" :loading="remitLoading">转 帐 完 成</el-button>
				<!-- <el-button v-if="type == 1" type="primary" @click="queryDialogVisible = false">关 闭</el-button> -->
				<el-button v-if="type == 4" type="primary" @click="reject" :loading="bhLoading">驳 回</el-button>
				<el-button  @click="queryDialogVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 查看 -->
		<el-dialog title="打款凭证" :visible.sync="showContentDialog" width="500px" :close-on-click-modal="false">
			<!-- <span v-html="contentValue"></span> -->
			<el-carousel v-if="contentValueArr.length>1" height="640px">
				<el-carousel-item v-for="item in contentValueArr" :key="item">
					<img :src="item" style="width: 100%;height: auto;" />
				</el-carousel-item>
			</el-carousel>
			<img v-if="contentValueArr.length==1" :src="contentValue" style="width: 100%;height: 640px;" />
			<!-- <span v-else>请上传图片</span> -->
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>


		<el-dialog title="发票凭证" :visible.sync="sjsjFlage" width="500px" :close-on-click-modal="false">
			<div >
				<div v-if="sjsjInfo.invoiceType ==1">
					<img  :src="sjsjInfo.invoiceImg" style="width: 100%;height: auto;" />
				</div>
				<div v-if="sjsjInfo.invoiceType ==2">
					<el-form class="demo-form-inline"  style="margin: 20px 0px 0px 20px;">
						<el-form-item label="快递单号:">
							<span>{{ sjsjInfo.expressCode }}</span>
						</el-form-item> 
						<el-form-item label="快递公司:">
							<span>{{ sjsjInfo.expressName }}</span>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('storeTX');
	export default {
		data() {
			return {
				httpUrl: urls,
				applyDatil: false, //申请提现弹窗
				dialogDatil: false,
				// 搜索部分
				integralWithdrawal:{},
				showContentDialog:false,
				payId:'',
				reason:'',
				searchInfo: {
					status: '',
					type: ''
				},
				loading: false,
				queryDialogVisible:false,
				withdrawal: {},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				payment: {},
				bhLoading:false,
				type:'',
				storeInfo: {},
				amount: '',
				contentValue:'',
				contentValueArr:[],
				limtInfo: {},
				count: 60,
				title:'',
				flag: true,
				timer: [],
				storeList: [],
				storeLoading: false,

				allData: {}, //总金额

				sjsjInfo: {},
				sjsjFlage: false,

				sureLoading: false,
				confirmLoading: false,
				remitLoading : false,
			}
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			onSuccess(response, file, fileList) {
				this.payment.systemDocuments = response.message
				// console.log('ssssss',response.data);
			},
			queryClick(item){
				this.sjsjInfo = item;
				this.sjsjFlage = true;
			},
			showContent(content) {
				this.contentValue = ''
				this.contentValueArr = []
				this.contentValue = content
				this.contentValueArr = this.contentValue.split(',')
				this.showContentDialog = true
			},
			remit() {
				this.remitLoading = true;
				this.$api.haveMoneyUpOrStartUsing(this.$encrypt(this.payment)).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.tixianList();
					} else {
						this.$message.error(res.message);
					}
					this.remitLoading = false;
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.tixianList()
			},
			// 清空
			empty() {
				this.timer = []
				this.searchInfo = {}
			},
			//导出
			downloadFile() {

			},
			reject(){
				this.bhLoading = true;
				// console.log(scope.row.id);
				
				this.$api.shenhePass(this.$encrypt({
					reason:this.reason,
					id:this.payId,
					status:4
				})).then((res) => {
				// 	console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						
						this.reason=''
						this.queryDialogVisible = false
						this.tixianList()
					} else {
						this.reason=''
						this.$message.error(res.message);
					}
					this.bhLoading = false;
				})
			},
			// 通过
			confirm(){
				this.confirmLoading= true;
				let data = {
					id:this.payId,
					status:1
				}
				this.$api.shenhePass(this.$encrypt(data)).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false
						this.tixianList()
					}else {
						this.$message.error(res.message);
					}
					this.confirmLoading= false;
				})
			},
			//申请提现
			applyWithdrawal() {
				this.applyDatil = true
				this.$api.byKey({
					key: 'Store_Withdrawal_Parameter'
				}).then(res => {
					res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.limtInfo = JSON.parse(res.data.settingValue)
						console.log(this.limtInfo);
					}
				})
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeInfo = res.data.store
						console.log(this.storeInfo);
					}
				})
			},
			// 商户撤销
			revoke(id) {
				console.log(id);
				this.$confirm('是否撤销该次提现?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(2222);
					this.$api.storeRovek(id).then(res => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.tixianList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					console.log(3333);
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			queryIntegralWithdrawal(item,type,title) {
				this.title=title
				console.log(title);
				this.type=type
				this.payId = item.id
				
				this.payment = item
			
					this.queryDialogVisible=true
				
			},
			code() {
				this.timeDown()
				this.$api.captCode({
					phone: this.storeInfo.phone,
					type: "register"
				}).then(res => {
					console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					}
				})
			},
			// 验证码倒计时
			timeDown() {
				this.count--;
				this.flag = false;
				var timer = setInterval(() => {
					if (this.count > 0) {
						this.count--;
						this.flag = false
					} else {
						clearInterval(timer)
						timer = null;
						this.count = 60;
						this.flag = true
					}
				}, 1000)
			},
			// 确认提交按钮
			sure() {

			},

			pageChange(data) {
				this.page.pageNum = data
				this.tixianList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.tixianList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			tixianList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.timer ? this.timer[0] : "",
					endTime: this.timer ? this.timer[1] : "",
					...this.searchInfo
				}
				// console.log('23400--',data )
				this.$api.storeTixian(this.$encrypt(data)).then(res => {
					res = JSON.parse(this.$decrypt(res.data))
					console.log('0000--',res.data)
					if (res.state == 'success') {
						// console.log(res);
						this.withdrawal = res.data
						this.loading = false
					}
				})
				
				this.$api.storeTixianGrossAmount(
					this.$encrypt({
						startTime: this.timer ? this.timer[0] : "",
						endTime: this.timer ? this.timer[1] : "",
						...this.searchInfo
					})
				).then(res => {
					res = JSON.parse(this.$decrypt(res.data))
					// console.log('22223--',res )
					if (res.state == 'success') {
						// console.log(res);
						this.allData = res.data
					}
				})
				
			},
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.storeList = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
				} else {
					this.storeList = [];
				}
			},
		},
		created() {
			this.tixianList()
		}
	}
</script>

<style scoped lang="less">
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
		
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}

	/deep/.el-input__inner {
		color: black !important;
	}

	/deep/.el-textarea__inner {
		color: black !important;
	}
</style>